import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export interface Config {
    environmentLabel: string;
    irasffUrl: string;
    tntUrl: string;
    qliksenseUrl: string;
    openPortalLink: string;
}

export interface Configuration {
    supportEmail: string;
    openPortalLink: string;
}

@Injectable({
    providedIn: 'root',
})
export class AppConfigService {
    private http = inject(HttpClient);

    private configUrl = './backend/config/';
    private configurationUrl = './backend/public/configuration/';

    getConfig() {
        return this.http.get<Config>(`${this.configUrl}`);
    }

    getConfiguration() {
        return this.http.get<Configuration>(`${this.configurationUrl}`);
    }
}
